export default class SatisfactionForm {
    static init() {
        document.querySelectorAll('.form--satisfaction').forEach(form => {
            const setNameAndEmailInputsAsRequired = function(event) {
                const required = event.target.checked;

                const fullNameInput = form.querySelector('input[name*=fullName]');
                const emailInput = form.querySelector('input[name*=email]');

                if (required) {
                    fullNameInput.setAttribute('required', true)
                    emailInput.setAttribute('required', true)
                } else {
                    fullNameInput.removeAttribute('required')
                    emailInput.removeAttribute('required')
                }
            }

            const checkbox = form.querySelector('input[type=checkbox][name*=takePartInRaffle]');
            checkbox.addEventListener('change', setNameAndEmailInputsAsRequired)
        })
    }
}
